import classNames from 'classnames';
import {MouseEventHandler} from 'react';
import styles from './VideoControlsItem.module.css';

type IProps = {
    children: React.ReactNode;
    onClick?: MouseEventHandler<HTMLDivElement>;
    onMouseEnter?: MouseEventHandler<HTMLDivElement>;
    onMouseLeave?: MouseEventHandler<HTMLDivElement>;
    className?: string;
};

const stopPropagation: MouseEventHandler<HTMLDivElement> = e => {
    e.stopPropagation();
};

export const VideoControlsItem = ({
    children,
    onClick = stopPropagation,
    onMouseEnter,
    onMouseLeave,
    className,
}: IProps) => {
    const handleClick: MouseEventHandler<HTMLDivElement> = e => {
        e.stopPropagation();
        onClick(e);
    };

    return (
        <div
            className={styles.item}
            onClick={handleClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className={classNames(styles.itemInner, className)}>
                {children}
            </div>
        </div>
    );
};
